"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexedPaths = exports.getMetaForPath = exports.baseMetaTag = exports.metaTags = void 0;
exports.metaTags = {
    // Homepage
    "/": {
        title: "Lingo: Digital Asset Library, Design System Manager & More",
        description: "Lingo is the visual home for your brand. It is designed to help teams organize, manage and share their assets in one place.",
    },
    // Product
    "/product/kits": {
        title: "Kits | Lingo",
        description: "Content and context in the same place. Kits are part document part asset library. Document every asset and aspect of your brand.",
    },
    "/product/library": {
        title: "Library | Lingo",
        description: "Manage your assets with ease. The Library brings all your assets and metadata into a single view designed specifically for asset management.",
    },
    "/product/insights": {
        title: "Insights | Lingo",
        description: "Measure the performance and impact of your assets using Lingo's powerful asset analytics",
    },
    "/product/custom-branding": {
        title: "Custom Branding | Lingo",
        description: "Replace Lingo's brandng with your own to make your workspace feel on-brand and official for anyone using it",
    },
    "/product/features": {
        title: "Features by Use Case | Lingo",
        description: "Lingo combines the power of a digital asset manager with the context of a style guide creator where users can upload, search, manage and share digital assets.",
    },
    "/product/integrations": {
        title: "Apps & Integrations  | Lingo",
        description: "Work from the web or your desktop and connect Lingo to the tools you already use so you can supercharge your workflow.",
    },
    "/integrations/figma": {
        title: "Figma Integration  | Lingo",
        description: "Assets created in Figma can be synced to Lingo so you can build style guides, illustration libraries and design systems that can be used by your entire organization.",
    },
    "/integrations/sketch": {
        title: "Sketch Plugin  | Lingo",
        description: "Sync your Sketch assets to Lingo and build style guides, illustration libraries and design systems that can be used by your entire organization.",
    },
    "/integrations/dropbox": {
        title: "Dropbox Integration  | Lingo",
        description: "Import assets directly from your Dropbox account.",
    },
    "/integrations/google": {
        title: "Google Drive Integration  | Lingo",
        description: "Import assets directly from your Google account.",
    },
    "/integrations/api": {
        title: "The Lingo API  | Lingo",
        description: "Build on top of our powerful platform to create customized workflows to suit your needs.",
    },
    // Solutions
    "/solutions/brand-guidelines": {
        title: "Brand Guidelines | Lingo",
        description: "Lingo allows you to create a comprehensive brand guideline that empowers everyone on your team to help identify, build, and grow your brand",
    },
    "/solutions/digital-asset-management": {
        title: "Digital Asset Management | Lingo",
        description: "Store all your digital assets in a single location. Make them easy to organize, share and use.",
    },
    "/solutions/digital-brand-hub": {
        title: "Digital Brand Hub | Lingo",
        description: "Create a single source of truth for your brand assets. Empower your team to create on their own while ensuring consistency at scale.",
    },
    "/solutions/brand-teams": {
        title: "Solution for Brand Teams | Lingo",
        description: "Use Lingo to create a single source of truth for your brand and ensure brand consistency at scale.",
    },
    "/solutions/agencies": {
        title: "Solution for Design Agencies | Lingo",
        description: "Use Lingo to build digital style guides for your clients. Save time and create more value for your clients.",
    },
    // Misc pages
    "/about": {
        title: "About | Lingo",
        description: "Looking for an affordable and easy to use digital asset manager? Lingo gives you the flexibility to manage all your digital assets in one place.",
    },
    "/pricing": {
        title: "Pricing & Plans for Every Business Size | Lingo",
        description: "Lingo offers an affordable design system pricing plan that scales with your organization. Book a demo or start your 30-day free trial today!",
    },
    "/legal": {
        title: "Legal | Lingo",
        description: "Lingo's legal statements.",
    },
    "/security": {
        title: "Security | Lingo",
        description: "Learn about our security practices and how we keep your data safe.",
    },
    "/enterprise": {
        title: "Enterprise Digital Asset Management Solutions | Lingo",
        description: "Looking for an affordable enterprise DAM system? With Lingo your team can maximize your brand's value with a fully customizable digital asset library.",
    },
    "/demo": {
        title: "Demo: How to Use Lingo | Lingo",
        description: "Learn how Lingo can help your team manage and share their digital asset libraries on their own while ensuring consistency at scale. Book a demo today!",
    },
    "/contact": {
        title: "Contact Us | Lingo",
        description: "Have a question about our products? Our Lingo team is happy to help you. Use the messenger to send us a message or visit our help center.",
    },
    "/accessibility": {
        title: "Accessibility | Lingo",
        description: "Lingo's accessibility statement.",
    },
    "/open": {
        title: "Open App | Lingo",
        description: "With Lingo you can build and share your digital assets and style guides quickly by downloading the Lingo Mac app and Sketch plugin. Get started today!",
    },
    "/blog": {
        title: "Blog | Lingo",
        description: "Blog posts by Lingo. Learn about new features and how companies are using Lingo to organize, manage and share their digital asset libraries.",
    },
};
exports.baseMetaTag = {
    description: "A modern digital asset manager for your brand and product",
    title: "Lingo — The visual home for your brand",
};
function getMetaForPath(path) {
    var p = path.toLowerCase();
    if (p !== "/" && p.endsWith("/")) {
        p = p.slice(0, -1);
    }
    return exports.metaTags[p] || exports.baseMetaTag;
}
exports.getMetaForPath = getMetaForPath;
exports.indexedPaths = Object.keys(exports.metaTags);
